import styles from './DeliveryHeaderPanelItem.module.css';
import { Text } from '@/_components';
import Link from 'next/link';
import { getClasses } from '@/_utils/classnames';
import type { FC } from 'react';
import type { DeliveryHeaderPanelItemProps } from './DeliveryHeaderPanelItem.types';

export const DeliveryHeaderPanelItem: FC<DeliveryHeaderPanelItemProps> = ({
  isActive,
  title,
  href,
}) => {
  const panelHeaderItemClasses: string = getClasses(styles.panelHeaderItem, {
    [styles.panelHeaderItemActive]: isActive,
  });

  return (
    <Link href={href} className={panelHeaderItemClasses}>
      <Text type="div" fontWeight="medium" color="currentcolor">
        {title}
      </Text>
    </Link>
  );
};
